import { Injector, NgModule } from "@angular/core";
import { Http, HttpModule, RequestOptions, XHRBackend } from "@angular/http";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from "./app-routing.module";
import { SessionTimeoutService, SharedModule } from "./shared";
import { httpFactory } from "./http.factory";
import {NgbDateParserFormatter, NgbModule} from "@ng-bootstrap/ng-bootstrap";
import { AppComponent } from "./app.component";
import { ServiceLocatorService } from "./shared/services/base-api/service-locator.service";
import { UtilService } from "./shared/services/util/util.service";
import { Store, StoreModule } from "@ngrx/store";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { SpinnerService } from "./shared/services/spinner/spinner.service";
import {DateParserFormatter} from "./shared/date-parser/date-parser";


@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    HttpModule,
    AppRoutingModule,
    NgbModule.forRoot(),
    StoreModule.forRoot({})
  ],
  providers: [
    SessionTimeoutService,
    SpinnerService,
    {
      provide: Http,
      useFactory: httpFactory,
      deps: [XHRBackend, RequestOptions, Store, SpinnerService]
    },
    UtilService,
    { provide: NgbDateParserFormatter, useClass: DateParserFormatter }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private injector: Injector) {
    ServiceLocatorService.injector = this.injector;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts